<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Proyección</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <pre-select-form
          v-show="!isDataLoaded"
          :preloaded-producer="preloadedProducer"
          :subtitle="subtitle"
          @selected="onSelect"
        />

        <projection-form
          v-if="isDataLoaded"
          :campaign="campaign"
          :producer="producer.businessName"
          @save="saveProjection"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProjectionForm from './Forms/ProjectionForm';
import PreSelectForm from '../../components/ModelSelects/PreSelectProducerCampaign';
import swal from 'sweetalert2';

export default {
  name: 'ProjectionsCreate',
  components: {
    RouteBreadCrumb,
    ProjectionForm,
    PreSelectForm,
  },

  data() {
    return {
      preloadedProducer: false,
      producerId: null,
      producer: null,
      campaign: null,
      subtitle: 'Elija la campaña y productor, y pulse en SELECCIONAR para realizar la proyección',
    };
  },

  computed: {
    isDataLoaded() {
      return this.campaign && this.producer;
    },
  },

  created() {
    this.producerId = this.$route.params.id || null;
    this.preloadedProducer = this.producerId !== null;

    if (this.preloadedProducer) {
      this.fetchProducer();
    }
  },

  methods: {
    onSelect(producer, campaign) {
      this.fetchCampaign(campaign);

      if (!this.preloadedProducer) {
        this.producerId = producer;
        this.fetchProducer();
      }
    },

    fetchCampaign(campaign) {
      this.$services
        .resource('campaigns')
        .show(campaign, { include: ['crops', 'articles'] })
        .then((res) => res.data.data)
        .then((campaign) => (this.campaign = campaign));
    },

    fetchProducer() {
      this.$services
        .resource('producers')
        .show(this.producerId)
        .then((res) => res.data.data)
        .then((producer) => (this.producer = producer));
    },

    saveProjection(projection) {
      projection.producer = this.producerId;
      this.$services
        .resource('projections')
        .create(projection)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'La proyección fue creada.',
            type: 'success',
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: 'Ir al listado',
            cancelButtonText: 'Nueva Proyección',
            confirmButtonClass: 'btn btn-secondary',
            cancelButtonClass: 'btn btn-success',
          }).then((choice) => {
            if (choice.value) {
              this.$router.push({ name: 'ProjectionsList' });
            } else {
              this.reset();
            }
          });
        })
        .catch((errors) => {
          // this.serverErrors = errors
        });
    },

    reset() {
      this.campaign = null;
      this.producer = null;
    },
  },
};
</script>
